import React from "react";
import {PermissionGuard} from "../../components/PermissionGuard";
import {StandardLayout} from "../../components/StandardLayout";
import {SystemInfoFeature} from "../../features/systemInfo";

const ALLOWED_PERMISSION = 'systemInfo'

const SystemInfoPage = ({
  userToken,
  userPermissions,
}) => (
  <PermissionGuard
    userToken={userToken}
    userPermissions={userPermissions}
    permissionKey={ALLOWED_PERMISSION}
  >
    <StandardLayout
      headerTitle="系統資訊"
      body={<SystemInfoFeature />}
    />
  </PermissionGuard>
)

export default SystemInfoPage
